/* eslint security/detect-object-injection: 0 */
import cloneDeep from 'lodash.clonedeep';


const transformObject = (transformMethod) => {
  const recursive = (elementsOrg) => {

    const elements = cloneDeep(elementsOrg);

    if (!elements) {
      return elements;
    }

    if (typeof elements === 'string') {
      return transformMethod(elements);
    }

    // note that this will not transform keys in prototype
    Object.keys(elements)
      .forEach((elementName => {
        elements[transformMethod(elementName)] =
          typeof elements[elementName] === 'object' ?
            recursive(elements[elementName]) :
            elements[elementName];

        if (transformMethod(elementName) !== elementName) {
          delete elements[elementName];
        }
      }));

    return elements;
  };

  return recursive;
};

const isUpperCase = (s) => s === s.toUpperCase();

const firstLetterUppercase =
  transformObject((s) => isUpperCase(s) ? s : s.charAt(0).toUpperCase() + s.slice(1));
const firstLetterLowercase =
  transformObject((s) => isUpperCase(s) ? s : s.charAt(0).toLowerCase() + s.slice(1));

export {
  firstLetterLowercase,
  firstLetterUppercase
};
